import { defineStore } from 'pinia';
import { AuthenticationStatusCode } from '@Enums/authenticationStatusCode.enum';
import { MfaStatus } from '@Enums/mfaStatus.enum';
import type { AccountUserRow, VerifyDeviceResponse, VerificationChannel } from '@Types/deviceAuth.interface';

export type DeliveryType = 'Sms' | 'PhoneCall' | 'Email';

export const useDeviceAuthStore = defineStore('deviceAuth', {
    state: () => ({
        isVerifying: false,
        statusCode: null as AuthenticationStatusCode | null,
        error: null as string | null,
        loginHint: null as string | null,
        connectionType: null as 'Sms' | 'Email' | null,
        lastDeliveryType: null as DeliveryType | null,
        mfaStatus: null as MfaStatus | null,
        matchedAccounts: null as AccountUserRow[] | null,
        availableChannels: null as VerificationChannel[] | null,
    }),
    actions: {
        handleVerifyDeviceResponse(response: VerifyDeviceResponse) {
            this.statusCode = response.statusCode;
            this.loginHint = response.loginHint ?? null;
            this.connectionType = (response.connectionType as 'Sms' | 'Email' | undefined) ?? null;
        },
        setVerifying(value: boolean) {
            this.isVerifying = value;
        },
        setError(message: string) {
            this.error = message;
        },
        setMatchedAccounts(accounts: AccountUserRow[]) {
            this.matchedAccounts = accounts;
        },
        setLastDeliveryType(value: DeliveryType | null) {
            this.lastDeliveryType = value;
        },
        setMfaStatus(value: MfaStatus | null) {
            this.mfaStatus = value;
        },
        setLoginHint(value: string | null) {
            this.loginHint = value;
        },
        setAvailableChannels(channels: VerificationChannel[] | null) {
            this.availableChannels = channels;
        },
        reset() {
            this.isVerifying = false;
            this.statusCode = null;
            this.error = null;
            this.loginHint = null;
            this.connectionType = null;
            this.lastDeliveryType = null;
            this.mfaStatus = null;
            this.matchedAccounts = null;
            this.availableChannels = null;
        },
    },
});
